import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

const defaultData: IDataLayer = {
  enh_action: 'refund',
  event_name: 'checkout_option',
  event_category: 'ecommerce',
  event_action: 'refund',
  event_label: null, // '<order ID>'
};

function trackCancelOrder(_: string, eventData: IDataLayer = {}) {
  eventData.event_label = eventData.order_id || '';
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('cancelOrder', trackCancelOrder);
